import { render, staticRenderFns } from "./detail-refund.vue?vue&type=template&id=0e7f47ce&"
import script from "./detail-refund.vue?vue&type=script&lang=js&"
export * from "./detail-refund.vue?vue&type=script&lang=js&"
import style0 from "./detail-refund.vue?vue&type=style&index=0&id=0e7f47ce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports